import { withAuthenticator } from '@aws-amplify/ui-react'
import React, { useEffect, useState } from 'react'
import { Course } from '@chrisdunne-com/chrisdunne-types'
import { Modal } from 'reactstrap'
import { deleteData, getData } from '../../utils/server'
import { Footer } from '../../components/footer'
import { Header } from '../../components/header'
import { Sidebar } from '../../components/sidebar'
import { Table } from '../../components/table'
import AddCourseModal from './courses-modal'
import { daysUntilReview } from '../../utils/resources'
import { SocialButton } from '../../components/social'

function TheCourses() {
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [modal_backdrop, setmodal_backdrop] = useState(false)
  const [modalCourse, setModalCourse] = useState<Course>()
  const [courses, setCourses] = useState<any[]>([])

  useEffect(() => {
    if (!success && !error) {
      getData('/course').then(
        (result: any) => {
          setSuccess(true)
          setCourses(result)
        },
        (error: any) => {
          setError(error)
        },
      )
    }
  })

  function tog_backdrop(item?: Course) {
    setModalCourse(undefined)
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()

    if (item) {
      setModalCourse(item)
    }
  }

  function put_course(course: Course) {
    if (courses.some((x) => x.slug === course.slug)) {
      const item = courses.findIndex((x) => x.slug === course.slug)
      courses[item] = course
    } else {
      setCourses([...courses, course])
    }
  }

  function removeBodyCss() {
    document.body.classList.add('no_padding')
  }

  function delete_item(slug: string) {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Are you sure you want to delete this Course?') === true) {
      deleteData('/course', slug).then(
        (result: any) => {
          setCourses(courses.filter((course) => course.slug !== slug))
        },
        (error: any) => {
          setError(error)
        },
      )
    }
  }

  return (
    <div>
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <h4 className="font-size-18">Courses</h4>
            <button
              type="button"
              className="btn btn-success float-end"
              onClick={() => {
                tog_backdrop()
              }}
              data-toggle="modal"
              style={{ marginRight: '50px' }}
            >
              Add New
            </button>
            <Modal
              size="lg"
              isOpen={modal_backdrop}
              toggle={() => {
                tog_backdrop()
              }}
              backdrop={'static'}
              id="staticBackdrop"
            >
              <AddCourseModal
                setmodal_backdrop={setmodal_backdrop}
                put_course={put_course}
                course={modalCourse}
              />
            </Modal>
            <Table columns={['🔗', 'Social', 'Title', 'Author', 'Review']}>
              {courses.map((item: Course, count) => (
                <tr
                  key={count}
                  className={
                    daysUntilReview(new Date(item.lastUpdated)) < 10
                      ? 'bg-danger'
                      : ''
                  }
                >
                  <td>
                    <a
                      href={`${process.env.REACT_APP_CHRIS_DUNNE_URL}/course/${item.slug}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bx-link-external"></i>
                    </a>
                  </td>
                  <td>
                    <SocialButton
                      text={`Check out this course by ${item.author.name}, "${item.title}"! ${item.description}`}
                      url={`https://chrisdunne.com/course/${item.slug}`}
                      hashtags="chrisdunne"
                    />
                  </td>
                  <td>{item.title}</td>
                  <td>{item.author.name}</td>
                  <td>{daysUntilReview(new Date(item.lastUpdated))} days</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        tog_backdrop(item)
                      }}
                      data-toggle="modal"
                    >
                      Update
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-light btn-sm"
                      onClick={() => {
                        delete_item(item.slug)
                      }}
                      data-toggle="modal"
                    >
                      <i className="bx bx-x"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </Table>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

export const Courses = withAuthenticator(TheCourses, {
  hideSignUp: true,
  loginMechanisms: ['email'],
})
